export function last4Digits(number?: string) {
  return number?.slice(-4);
}
